if (!customElements.get('selling-plan-selector')) {
  customElements.define(
    'selling-plan-selector',
    class SellingPlanSelector extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.planInput = this.querySelector('[data-selling-plan-input]');
        this.changeHandler = this.handleChange.bind(this);
        this.addEventListener('change', this.changeHandler);
        this.syncSelection();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(
            PUB_SUB_EVENTS.variantChange,
            this.handleVariantChange.bind(this)
          );
        }
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.changeHandler);
        this.variantChangeUnsubscriber?.();
      }

      handleChange(event) {
        if (!event.target.matches('input[type="radio"]')) return;
        this.syncSelection();
      }

      syncSelection() {
        const selected = this.querySelector('input[type="radio"]:checked');
        if (!selected || !this.planInput) return;

        if (selected.value === 'one-time') {
          this.planInput.value = '';
          this.planInput.disabled = true;
        } else {
          this.planInput.value = selected.value;
          this.planInput.disabled = false;
        }
      }

      handleVariantChange({ data }) {
        if (!data?.html || !data.sectionId || !this.id.endsWith(data.sectionId)) return;
        const replacement = data.html.getElementById(this.id);
        if (replacement) this.replaceWith(replacement);
      }
    }
  );
}
